import { z } from "zod";

import { RoleGroupEnum } from "@classview/shared-types";

const userPermissionsSchema = z.object({
  isOrganisationManagementEnabled: z.boolean(),
  isUserManagementEnabled: z.boolean(),
  isJobPostingEnabled: z.boolean(),
  roleGroup: z.nativeEnum(RoleGroupEnum),
  isEventManagementEnabled: z.boolean(),
});

type UserPermissionsFormData = z.infer<typeof userPermissionsSchema>;

export { userPermissionsSchema };
export type { UserPermissionsFormData };
